export class LocatorMap {

    constructor ( google ) {

        this.google = google;

        this.$map;
        this.markers = [];
        this.prev = {};
        this.locations = []
        this.filters = {};

        this.$locatorButtons = [];

    }

    addMarkers ( markers ) {
        this.markers = [
            ...this.markers,
            markers
        ]
    }

    init () {

        //this.$loader = document.querySelector( '.c-loader' );
        this.$tabs = document.querySelector( '.js-tabs' );
        this.$map = document.getElementById( 'locator_map' );
        this.$locatorButtons = Array.from( document.querySelectorAll( '.js-locator-button' ) )
        this.listener = this.fitMap.bind( this );
        this.form = document.querySelector( '.js-filter__form' );

        fetch( this.$map.dataset.load ).then( res => {
            res.json().then( res => {
                this.locations = res.houses
                this.createMap();
                this.fitMap();
            } )
        } )

    }

    createMap () {
        if ( this.$map ) {

            // Set up a boundary object to keep markers in view
            this.bounds = new this.google.maps.LatLngBounds();

            // Cache infowindow
            this.infowindow = new this.google.maps.InfoWindow( {
                'content': 'Loading...'
            } );

            this.google.maps.event.addListener( this.infowindow, 'closeclick', function() {
                this.$map.setCenter( this.prev.center );
                this.$map.setZoom( this.prev.zoom );
            } );

            // init map
            this.$map = new this.google.maps.Map( document.getElementById( 'locator_map' ), {
                center: new this.google.maps.LatLng( 53.28614, -0.543936 ),
                zoom: 7
            } );

            if ( this.locations.length > 0 ) {
                this.locations.forEach( location => {
                    this.addMarker( location )
                } );
            }

            this.form.addEventListener( 'change', () => {
                    this.createFilters()
                }
            )


            this.mapItems = Array.from( document.querySelectorAll( '.js-map__item' ) );

            this.mapItems.forEach( item => {
                item.addEventListener( 'click', () => {
                    const id = item.dataset.marker;

                    this.markers = this.markers.map( marker => {
                        marker.setVisible( false );

                        if ( marker.id === id ) {
                            marker.setVisible( true );
                            this.google.maps.event.trigger( marker, 'click' );
                        }

                        return marker;
                    } );
                } )
            } )
        }

        if ( this.$tabs ) {
            Array.from( this.$tabs.querySelectorAll( '.js-tabs__button' ) )[ 0 ].addEventListener( 'click', this.listener, true );
        }

        this.addButtonEvents();

    }


    fitMap () {
        setTimeout( () => {
            this.$map.fitBounds( this.bounds );
            this.$tabs.removeEventListener( 'click', this.listener, true );
            //this.$loader.classList.add( 'c-loader--hidden' );
        }, 100 )
    }

    addMarker ( location ) {
        let html = `<div class="c-card">
                        <h2 class="c-card__title">
                            ${location.addressTitle}
                        </h2>
                        <h3 class="c-card__subtitle">
                            ${location.addressTown}
                        </h3>
                        <div class="c-card__copy">
                            <p> ${location.excerpt}</p>
                        </div>
                        <div class="c-card__actions">
                            <a href="${location.url}" class="c-button">
                                Find out more
                            </a>
                        </div>
`;

        location.marker = new this.google.maps.Marker( {
            position: new this.google.maps.LatLng( location.addressLatitude, location.addressLongitude ),
            map: this.$map,
            animation: this.google.maps.Animation.DROP,
            icon: {
                url: '/assets/images/lace-map-icon.svg',
                scaledSize: new this.google.maps.Size( 60, 35 ),
                origin: new this.google.maps.Point( 0, 0 ),
                anchor: new this.google.maps.Point( 17, 48 )
            },
            id: location.addressID,
            title: location.addressTitle,
            content: html
        } );

        this.google.maps.event.addListener( location.marker, 'click', () => {
            // Save previous
            this.prev = {
                center: this.$map.getCenter(),
                zoom: this.$map.getZoom()
            };

            // Update
            this.infowindow.setContent( location.marker.content );
            this.infowindow.open( this.$map, location.marker );
        } );

        this.addMarkers( location.marker );
        this.bounds.extend( location.marker.getPosition() );
    }

    addButtonEvents () {
        this.$locatorButtons.forEach( $button => {
            $button.addEventListener( 'click', () => {

                window.tabs.switchTab( window.tabs.tabs[ 0 ], 1 );
                this.fitMap();
                const id = $button.dataset.marker;

                this.markers = this.markers.map( marker => {

                    if ( marker.id === id ) {
                        this.infowindow.setContent( marker.content );
                        this.infowindow.open( this.$map, marker );
                    }

                    return marker;
                } );
            } )
        } )
    }


    createFilters () {
        Array.from( this.form.elements ).forEach( ( filter ) => {
            let name = filter.name.split( '[' );

            if ( !this.filters[ name[ 0 ] ] ) {
                this.filters[ name[ 0 ] ] = []
            }
            if ( filter.checked ) {
                this.filters[ name[ 0 ] ][ name[ 1 ].replace( ']', '' ) ] = filter.checked
            } else {
                delete this.filters[ name[ 0 ] ][ name[ 1 ].replace( ']', '' ) ]
            }
        } );


        Object.keys( this.filters ).filter( filter => {
            if ( Object.keys( this.filters[ filter ] ).length === 0 ) {
                delete this.filters[ filter ];
            }
        } )

        this.filterLocations();
    }

    filterLocations () {
        this.locations.forEach( location => {

            let match = true;
            for ( const filter in this.filters ) {
                if ( filter in location ) {
                    //Checks if the current filter is process and splits into array
                    const categories = Object.keys( this.filters[ filter ] );

                    if ( categories.length > 0 ) {
                        let contains = false
                        categories.forEach( category => {
                            if ( location[ filter ].includes( category.toLowerCase() ) ) {
                                contains = true
                            }
                        } );
                        match = ( match && contains );
                    }
                }
            }

            if ( match ) {
                if ( location.marker === undefined ) {
                    this.addMarker( location );
                }
            } else {
                if ( location.marker !== undefined ) {
                    location.marker.setMap( null );
                    delete location.marker
                }
            }
        } )
    }
}
